'use client'

import dynamic from 'next/dynamic'

const ToastContainer = dynamic(
    () => import('react-toastify').then((module) => module.ToastContainer),
    { ssr: false },
)

const LazyToastContainer = () => (
    <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{ zIndex: 99999, top: '90px' }}
    />
)

export default LazyToastContainer
